var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7711 4.22878C12.0314 4.48913 12.0314 4.91124 11.7711 5.17159L8.94265 8.00002L11.7711 10.8284C12.0314 11.0888 12.0314 11.5109 11.7711 11.7713C11.5107 12.0316 11.0886 12.0316 10.8283 11.7713L7.99984 8.94283L5.17141 11.7713C4.91106 12.0316 4.48895 12.0316 4.2286 11.7713C3.96825 11.5109 3.96825 11.0888 4.2286 10.8284L7.05703 8.00002L4.2286 5.17159C3.96825 4.91124 3.96825 4.48913 4.2286 4.22878C4.48895 3.96843 4.91106 3.96843 5.17141 4.22878L7.99984 7.05721L10.8283 4.22878C11.0886 3.96843 11.5107 3.96843 11.7711 4.22878Z",
    fill: "#033D8B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close-small.0db6b562f5d3309cc2ecca385e3b251d.svg";
export { ForwardRef as ReactComponent };